exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-title[data-v-2419bf54]{font-size:12px;font-weight:700}.slide2-right-on-hover[data-v-2419bf54]{overflow:hidden;white-space:nowrap;display:inline-block}.slide2-right-on-hover .hover-on-text[data-v-2419bf54]{opacity:0;max-width:0;display:inline-block;transition:max-width .1s ease-out .1s,opacity .1s ease-out .1s,color;font-size:10px;font-weight:400}.slide2-right-on-hover:hover .hover-on-text[data-v-2419bf54]{opacity:1;max-width:150px;transition:max-width .5s ease-out .1s,opacity .5s ease-out .1s,color .2s}", ""]);

// exports
